import React from 'react';
import { connect } from 'react-redux';
import { locationError, receiveLocation } from '../../actions/location';
import { getLocationUrl } from '../../core/dapi/location';
import { apiGetDispatchable, apiPatchDispatchableWithoutSource } from '../../core/dapi';
import { getBookingById } from '../../core/dapi/newBooking';
import { receiveBooking, bookingError } from '../../actions/account';
import { getPublicBookingByIdUrl } from '../../core/dapi/waitList';
import PhotoIdUploadPrompt from './components/PreVisitPrompt/components/PhotoIdUploadPrompt';
import withAuthentication from '../../core/login/withAuthentication';
import {
  getNextRouteForAfterPhotoIdUpload,
  getRouteForTelemedFlowBeforePhotoIdUpload,
} from '../../core/util/videoVisit';
import history from '../../core/history';
import { analyticsTrackEvent } from '../../core/analytics';
import { PRE_VISIT_PROMPT_CLICK_PHOTO_ID_SKIP } from '../../core/analytics/events';
import { getActiveProfileFromState } from '../../core/util/account';
import { setProgressBarSteps } from '../../ducks/videoVisit';

const mapStateToProps = (state: any) => ({
  booking: state.account.booking || {},
  bookingError: state.account.bookingError,
  persistentStateLoaded: state.runtime.persistentStateLoaded,
  location: state.location,
  isTokBoxRatingSubmitted: Boolean(state.account.isTokBoxRatingSubmitted),
  numberOfBookingsAhead: state.videoVisit.numberOfBookingsAhead,
  sessionTrackingProperties: state.sessionTrackingProperties,
  accountSummary: state.account.summary,
  userProfile: getActiveProfileFromState(state),
  progressBarSteps: state.videoVisit.progressBarSteps,
});

const mapDispatchToProps = (dispatch: any, ownProps: any) => ({
  fetchBooking: () =>
    dispatch(apiGetDispatchable(getBookingById(ownProps.bookingId), receiveBooking, bookingError)),

  fetchPublicBooking: () =>
    dispatch(
      apiGetDispatchable(getPublicBookingByIdUrl(ownProps.bookingId), receiveBooking, bookingError)
    ),

  patchBooking: (bookingId: any, patchData: any) => {
    dispatch(
      apiPatchDispatchableWithoutSource(
        getBookingById(bookingId),
        patchData,
        receiveBooking,
        bookingError
      )
    );
  },

  handleSkip: ({
    booking,
    location,
    trackingProperties,
    userProfile,
  }: {
    booking: any;
    location: any;
    trackingProperties: any;
    userProfile: any;
  }) => {
    analyticsTrackEvent(PRE_VISIT_PROMPT_CLICK_PHOTO_ID_SKIP, trackingProperties);
    history.push(getNextRouteForAfterPhotoIdUpload(booking, location, userProfile));
  },

  handleGoBack: ({
    booking,
    location,
    bookingId,
  }: {
    booking: any;
    location: any;
    bookingId: string;
  }) => {
    history.push(getRouteForTelemedFlowBeforePhotoIdUpload(booking, location, bookingId));
  },

  fetchLocation: (locationId: any) => {
    dispatch(
      apiGetDispatchable(getLocationUrl(locationId), receiveLocation, locationError(locationId))
    );
  },

  setProgressBarSteps: (steps: any) => dispatch(setProgressBarSteps(steps)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthentication(PhotoIdUploadPrompt));
